import React, { useState, useEffect } from 'react'
import useRouter from 'utils/useRouter'
import { Card, CardContent, CircularProgress, Grid, Typography } from '@material-ui/core'
import { Page, Header } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { useRequisicaoService } from 'hooks/useRequisicaoService'
import { CardCaso } from 'components/Cards/CardCaso'
import { MenuAcoes } from './components/MenuAcoes'
import useStyles from './styles'
import { useParams } from 'react-router'
import { ExibirArquivo } from 'components/ExibirArquivo'

export const Requisicao = (props) => {
  moment.locale('pt-br', localization)
  const { route } = props
  const router = useRouter()
  const params = useParams()
  const classes = useStyles()
  const requisicaoService = useRequisicaoService()
  const [requisicao, setRequisicao] = useState(null)
  const [processandoRequisicao, setProcessandoRequisicao] = useState(false)

  useEffect(() => {
    const fetchRequisicao = async () => {
      const result = await requisicaoService.listarRequisicaoPorIdAsync(params.id, setProcessandoRequisicao)
      setRequisicao(result)
    }
    fetchRequisicao()
  }, [params.id])

  const handleClickCaso = (id, novaAba) => {
    if (novaAba) {
      window.open(`/casos/caso/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/detalhar/${id}`)
    }
  }

  return (
    <Page className={classes.root} tittle={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      {processandoRequisicao || !requisicao ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          <Card className={classes.results}>
            <CardContent>
              <div>
                <Grid alignItems="flex-end" container justifyContent="space-between" style={{ borderBottom: 'thin solid #DDD' }}>
                  <Grid item>
                    <Typography gutterBottom>
                      <b>DADOS DE ENTRADA</b>
                    </Typography>
                  </Grid>
                  <Grid item>
                    <MenuAcoes requisicao={requisicao} />
                  </Grid>
                </Grid>
              </div>

              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between">
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Identificador</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.identificador?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Resumo da ocorrência</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.resumo_ocorrencia?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Tipo</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.tipo?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Orgão</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.orgaoOrigem.nome?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Autoridade Requisitante</b>
                  </Typography>
                  <Typography variant="body2">
                    {requisicao.autoridadeRequisitante.nome?.toUpperCase()}
                    {' - '}
                    {requisicao.autoridadeRequisitante.matricula?.toUpperCase()}
                  </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>NIC</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.nic?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Setor solicitante</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.setorSolicitante.nome?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Setor de destino</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.setorDestino.nome?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Status</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.status?.toUpperCase().replace(/_/g, ' ') || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Identificador Caso RIP</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.identificador_caso_rip?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Observações</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.observacoes?.toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Data do cadastro</b>
                  </Typography>
                  <Typography variant="body2">{moment(requisicao.createdAt).format('LLLL').toUpperCase() || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <Typography variant="body1">
                    <b>Tipo Específico</b>
                  </Typography>
                  <Typography variant="body2">{requisicao.tipo_especifico?.toUpperCase().replace(/_/g, ' ') || 'NÃO INFORMADO'} </Typography>
                </Grid>
                <Grid className={classes.item} item md={8} sm={8} xs={12}>
                  <Typography variant="body1">
                    <b>Exames Solicitados</b>
                  </Typography>
                  <Typography variant="body2" component="ul">
                    {requisicao.tipoExames.length > 0 ? (
                      requisicao.tipoExames.map((exame, index) => (
                        <Typography key={index} component="li" style={{ marginLeft: '15px' }}>
                          {exame.nome?.toUpperCase() || 'NÃO INFORMADO'}
                        </Typography>
                      ))
                    ) : (
                      <Typography component="li" style={{ marginLeft: '15px' }}>
                        Nenhum exame informado
                      </Typography>
                    )}
                  </Typography>
                </Grid>
                <Grid className={classes.item} item md={8} sm={8} xs={12}>
                  <Typography variant="body1">
                    <b>Quesitos</b>
                  </Typography>
                  <Typography variant="body2" component="ul">
                    {requisicao.quesitos.length > 0 ? (
                      requisicao.quesitos.map((quesito, index) => (
                        <Typography key={index} component="li" style={{ marginLeft: '15px' }}>
                          {quesito.quesito?.toUpperCase() || 'NÃO INFORMADO'}
                        </Typography>
                      ))
                    ) : (
                      <Typography component="li" style={{ marginLeft: '15px' }}>
                        Nenhum quesito informado
                      </Typography>
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between" md={12} sm={12} xs={12}>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography gutterBottom className={classes.titleCampo}>
                    <b>CASO RELACIONADO</b>
                  </Typography>
                </Grid>
                {requisicao.caso ? (
                  <Grid item md={3} sm={9} xs={12} style={{ marginTop: '10px', marginRight: '20px', marginLeft: '8px' }}>
                    <CardCaso caso={requisicao.caso} handleClick={handleClickCaso} />
                  </Grid>
                ) : (
                  <Grid container className={classes.fieldGroup} justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
                    <Typography variant="body1">Nenhum caso relacionado</Typography>
                  </Grid>
                )}
              </Grid>
              <Grid className={classes.fieldGroup} alignItems="center" container justifyContent="space-between" md={12} sm={12} xs={12} style={{ marginTop: '20px' }}>
                <Grid item md={12} sm={12} xs={12} className={classes.gridTitle}>
                  <Typography gutterBottom className={classes.titleCampo}>
                    <b>ARQUIVOS RELACIONADOS</b>
                  </Typography>
                  {requisicao?.arqs?.length ? (
                    <Grid item md={12} sm={12} xs={12}>
                      <Grid container justifyContent="flex-start" alignItems="center">
                        {requisicao.arqs.map((arquivo) => (
                          <Grid className={classes.item} item md={2} sm={4} xs={8}>
                            <ExibirArquivo id={arquivo.id} rotaLoadFile="/arquivo/requisicao" />
                          </Grid>
                        ))}
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid item md={12} sm={12} xs={12}>
                      <Typography variant="body2" color="textSecondary">
                        A requisição não possui arquivos relacionados.
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>
      )}
    </Page>
  )
}
